import {RouteConfig} from 'vue-router';

export const loginRoutes : RouteConfig = {
  path: 'login',
  component: () => import('@/views/public/login/LoginView.vue'),
  children: [
    {
      path: '',
      name: 'login',
      component: () => import('@/views/public/login/index/LoginIndex.vue'),
    },
  ],
};
